<template>
  <div class="animated fadeIn">
    <b-card v-if="data !== null">
      <div slot="header">
        <b-button :to="{name: 'vote-item', params: {appId: this.$route.params.appId, save: true}, query: {oversea: !!JSON.parse($route.query.oversea)}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        <strong>{{ funcType }}</strong> 投票项{{ !!JSON.parse($route.query.oversea) ? overseaTag : '' }}
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <template v-for="(item, idx) in customField">
          <b-form-group
            :key="'custom' + idx"
            :label="item.text"
            :label-for="item.field"
          >
            <b-form-input v-if="item.tag === 'input'" v-model="data[item.field]" :id="item.field" :type="item.type" required />
            <b-form-checkbox v-else-if="item.tag === 'judge'" switch v-model="data[item.field]" @click="data[item.field] = !data[item.field]" required />
          </b-form-group>
        </template>
        <b-form-group label="是否上线">
          <b-form-checkbox switch v-model="data.online" @click="data.online = !data.online" required />
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check" /> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-repeat" /> 复位</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'vote-iItem-form',
  mixins: [Error],
  props: ['func', 'isUpdate', 'defaultLimitConfig'],
  data () {
    return {
      appId: this.$route.params.appId,
      itemId: this.$route.params.itemId,
      service: null,
      data: null,
      staticData: null,
      funcType: this.func,
      update: this.isUpdate,
      customField: null,
      limitConfigFields: consts.VOTE_ITEM_LIMIT_CONFIG_FIELDS,
      limit_config_options: consts.VOTE_LIMIT_CONFIG_OPTIONS,
      limit_start_date: '',
      limit_end_date: '',
      limit_start_time: '',
      limit_end_time: '',
      limitMinEndTime: '',
      overseaTag: consts.overseaTag
    }
  },
  created () {
    let reqData = {
      path: api.getVoteDetail(),
      type: JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : process.env.NODE_ENV.slice(0, 3),
      method: 'GET',
      data: {app_id: this.appId}
    }
    this.$ajax.post(api.getBaseUrl() + 'vote_project', reqData).then((data) => {
      this.service = data['data']
      this.$nextTick(function () {
        this.getFieldsAndItems()
      })
    }, (res) => {
      this.handleError(res)
    })
  },
  watch: {
    'data.limit_config.is_limit': function () {
      if (!this.data.limit_config.is_limit) {
        this.data.limit_config.every = null
        this.data.limit_config.user_limit_num = null
      }
    },
    limit_start_date: function () {
      this.limitMinEndTime = this.limit_start_date
      if (this.limit_start_date > this.limit_end_date) {
        this.limit_end_date = ''
      }
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.$emit('submitData', this.handleData())
    },
    onReset (evt) {
      evt.preventDefault()
      this.data = JSON.parse(JSON.stringify(this.staticData))
      this.limitMinEndTime = ''
      this.resetDateAndTime(this.staticData)
    },
    getFieldsAndItems () {
      // get fields
      let staticFields = [...consts.VOTE_ITEM_STATIC_FIELDS_1.map(i => Object.keys(i)[0]), ...consts.VOTE_ITEM_STATIC_FIELDS_2.map(i => Object.keys(i)[0])]
      let fields = []
      let data = {}
      let tableConfig = this.service.table_config
      for (let key in tableConfig) {
        if (key.indexOf('list') !== -1) {
          for (let idx in tableConfig[key].fields) {
            if (staticFields.indexOf(tableConfig[key].fields[idx].field) === -1 && tableConfig[key].fields[idx].field !== 'limit_config') {
              let tmpDict = {}
              let typeDict = consts.SQL_TYPE_DICT[tableConfig[key].fields[idx].type]
              tmpDict.text = tableConfig[key].fields[idx].field
              tmpDict.field = tableConfig[key].fields[idx].field
              tmpDict.tag = typeDict.tag
              if (typeDict.hasOwnProperty('type')) {
                tmpDict.type = typeDict.type
              }
              fields.push(tmpDict)
              data[tableConfig[key].fields[idx].field] = ''
            }
          }
          break
        }
      }
      this.customField = fields
      // get data
      if (!this.update) {
        this.data = {...data, ...{online: false, limit_config: JSON.parse(JSON.stringify(this.defaultLimitConfig))}}
        this.staticData = JSON.parse(JSON.stringify({...data, ...{online: false, limit_config: JSON.parse(JSON.stringify(this.defaultLimitConfig))}}))
        this.resetDateAndTime(this.staticData)
      } else { // get items
        let reqData = {
          path: api.getVoteItemDetail(),
          type: JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : process.env.NODE_ENV.slice(0, 3),
          method: 'GET',
          data: {
            app_id: this.appId,
            vote_id: this.itemId
          }
        }
        this.$nextTick(function () {
          this.$ajax.post(api.getBaseUrl() + 'vote_project', reqData).then((data) => {
            this.data = data['data']['vote_info']
            this.staticData = JSON.parse(JSON.stringify(data['data']['vote_info']))
            this.resetDateAndTime(this.staticData)
            this.data.online = !!this.data.online
            this.staticData.online = !!this.staticData.online
          }, (res) => {
            this.handleError(res)
          })
        })
      }
    },
    resetDateAndTime (data) {
      let startInfo = data.limit_config.limit_start_time.split('-')
      this.limit_start_date = startInfo.slice(0, 3).join('-')
      this.limit_start_time = startInfo.slice(3).join(':')
      let endInfo = data.limit_config.limit_end_time.split('-')
      this.limit_end_date = endInfo.slice(0, 3).join('-')
      this.limit_end_time = endInfo.slice(3).join(':')
    },
    handleData () {
      if (!this.data.online) {
        this.data.online = false
      }
      this.data.limit_config.limit_start_time = this.limit_start_date + '-' + this.limit_start_time.split(':').join('-')
      this.data.limit_config.limit_end_time = this.limit_end_date + '-' + this.limit_end_time.split(':').join('-')
      if (!this.update) {
        return {
          app_id: this.appId,
          vote: this.data
        }
      } else {
        return this.judgeUpdateData()
      }
    },
    judgeUpdateData () {
      let updatedData = {
        app_id: this.appId,
        vote: {
          vote_id: this.itemId,
          online: this.data.online
        }
      }
      for (let key in this.data) {
        if (JSON.stringify(this.data[key]) !== JSON.stringify(this.staticData[key])) {
          updatedData.vote[key] = this.data[key]
        }
      }
      return updatedData
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VoteItemForm.vue?3a5ce196